// extracted by mini-css-extract-plugin
export var form = "index-module--form--YTeBs";
export var formItems = "index-module--formItems--yUpVF";
export var logo = "index-module--logo--6nyAw";
export var signUpBtn = "index-module--signUpBtn--+bWBv";
export var signup = "index-module--signup--WTths";
export var top = "index-module--top--z5H0Z";
export var uploadBtn = "index-module--uploadBtn--LogdF";
export var uploadFile = "index-module--uploadFile--1MYeA";
export var uploadIcon = "index-module--uploadIcon--dDwFb";